module.exports = __webpack_public_path__ + "static-H5/img/loading.89617f2d.gif";